import { config } from 'lib-shared-backend-config';
import { lazy } from 'react';
import { loadComponent } from 'utils/remoteComponent';
const url = getKnowledgeURL();
const scope = 'knowledge';
export const RemoteKnowledgeManagementRoutes = lazy(loadComponent(scope, 'KnowledgeRoutes', url)); // KnowledgeRoutes to be renamed to KnowledgeManagementRoutes
export const RemoteKnowledgeDeliveryRoutes = lazy(loadComponent(scope, 'KnowledgeDeliveryRoutes', url));
export const RemoteKnowledgeSuggestions = lazy(loadComponent(scope, 'KnowledgeSuggestions', url));
export const RemoteKnowledgeHelpCenterRoutes = lazy(loadComponent(scope, 'KnowledgeHelpCenter', url));
function getKnowledgeURL(backendDomain = config.backendDomain) {
    // NOTE: if you would like to test against a local instance of knowledge-fe uncomment the next line
    // return 'http://localhost:8082/remoteEntry.js';
    if (backendDomain === null || backendDomain === void 0 ? void 0 : backendDomain.includes('stag')) {
        return 'https://knowledge.stag.dixa.io/remoteEntry.js';
    }
    return 'https://knowledge.dixa.io/remoteEntry.js';
}
